var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONResolver } from "graphql-scalars";
import { Field, ObjectType } from "type-graphql";
import { AccessLevel, AuthSource, DbRole, } from "../../authorization/structures.js";
import { EffectiveCommitteeRole } from "../types/EffectiveCommitteeRole.js";
let LoginState = class LoginState {
    loggedIn;
    dbRole;
    authSource;
    accessLevel;
    effectiveCommitteeRoles;
    abilityRules;
};
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], LoginState.prototype, "loggedIn", void 0);
__decorate([
    Field(() => DbRole, { nullable: false }),
    __metadata("design:type", String)
], LoginState.prototype, "dbRole", void 0);
__decorate([
    Field(() => AuthSource, { nullable: false }),
    __metadata("design:type", String)
], LoginState.prototype, "authSource", void 0);
__decorate([
    Field(() => AccessLevel, { nullable: false }),
    __metadata("design:type", Number)
], LoginState.prototype, "accessLevel", void 0);
__decorate([
    Field(() => [EffectiveCommitteeRole], { nullable: false }),
    __metadata("design:type", Array)
], LoginState.prototype, "effectiveCommitteeRoles", void 0);
__decorate([
    Field(() => [[JSONResolver]], { nullable: false }),
    __metadata("design:type", Array)
], LoginState.prototype, "abilityRules", void 0);
LoginState = __decorate([
    ObjectType("LoginState")
], LoginState);
export { LoginState };
//# sourceMappingURL=LoginState.js.map